<mat-toolbar class="toolbar">
  <h1>Stabilité OCPP</h1>
  <button mat-icon-button type="button" aria-label="Analyse précédente" [disabled]="selectedIndex <= 0" (click)="previous()">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <mat-form-field class="picker" subscriptSizing="dynamic">
    <mat-label>Analyse</mat-label>
    <mat-select [value]="selectedId" (selectionChange)="selectAnalysis($event.value)" [disabled]="analyses.length === 0">
      <mat-option *ngFor="let analysis of analyses" [value]="analysis.id">
        {{ analysis.createdAt | date:'dd/MM/yy HH:mm' }} · {{ triggerLabel(analysis.trigger) }} · {{ statusLabel(analysis.status) }}
        <ng-container *ngIf="analysis.parameters"> · {{ analysis.parameters.windowStart | date:'dd/MM' }} → {{ analysis.parameters.windowEnd | date:'dd/MM' }}</ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button type="button" aria-label="Analyse suivante" [disabled]="selectedIndex < 0 || selectedIndex >= chronological.length - 1" (click)="next()">
    <mat-icon>chevron_right</mat-icon>
  </button>
  <mat-form-field class="picker" subscriptSizing="dynamic">
    <mat-label>Comparer avec</mat-label>
    <mat-select [value]="comparisonId" (selectionChange)="onComparison($event.value)" [disabled]="comparisonOptions.length === 0 && !comparisonId">
      <mat-option value="">Aucune</mat-option>
      <mat-option *ngFor="let option of comparisonOptions" [value]="option.id">
        {{ option.createdAt | date:'dd/MM/yyyy HH:mm' }} · {{ triggerLabel(option.trigger) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button class="delete" mat-stroked-button type="button" (click)="confirmDelete()" [disabled]="!job">
    <mat-icon>delete</mat-icon>
    Supprimer
  </button>
  <button mat-flat-button color="primary" type="button" (click)="launch()">Nouvelle analyse</button>
</mat-toolbar>

<p class="legend" *ngIf="comparison">
  Écarts par rapport au {{ comparison.createdAt | date:'dd/MM/yyyy HH:mm' }}.
  Vert : amélioration. Rouge : dégradation.
</p>

<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<p class="error" *ngIf="loadError">{{ loadError }}</p>

<section class="empty-state" *ngIf="!loading && analyses.length === 0 && !loadError">
  <p>Aucune analyse enregistrée.</p>
</section>

<section *ngIf="job as current">
  <mat-progress-bar
    *ngIf="current.status === 'QUEUED' || current.status === 'RUNNING'"
    mode="determinate"
    [value]="current.progressTotal > 0 ? (current.progressDone / current.progressTotal) * 100 : 0">
  </mat-progress-bar>
  <p *ngIf="current.status === 'QUEUED' || current.status === 'RUNNING'">
    Analyse en cours · {{ current.progressDone }} / {{ current.progressTotal }} bornes
  </p>
  <p class="error" *ngIf="current.status === 'FAILED'">{{ current.errorMessage || 'Analyse en échec' }}</p>

  <ng-container *ngIf="current.result as result">
    <div class="cards">
      <article class="card">
        <span>Bornes</span>
        <strong>{{ result.summary.chargePointCount }}</strong>
        <em *ngIf="delta(result.summary.chargePointCount, comparison?.result?.summary?.chargePointCount, 'neutral') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>Sessions</span>
        <strong>{{ result.summary.sessionCount }}</strong>
        <em *ngIf="delta(result.summary.sessionCount, comparison?.result?.summary?.sessionCount, 'neutral') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>&lt; 10 s</span>
        <strong>{{ formatPercent(result.summary.veryShortRate) }}</strong>
        <em *ngIf="delta(result.summary.veryShortRate, comparison?.result?.summary?.veryShortRate, 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>&lt; 60 s</span>
        <strong>{{ formatPercent(result.summary.shortRate) }}</strong>
        <em *ngIf="delta(result.summary.shortRate, comparison?.result?.summary?.shortRate, 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>Rafales</span>
        <strong>{{ formatPercent(result.summary.burstRate) }}</strong>
        <em *ngIf="delta(result.summary.burstRate, comparison?.result?.summary?.burstRate, 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>Présence</span>
        <strong>{{ formatPercent(result.summary.uptimeRatio) }}</strong>
        <em *ngIf="delta(result.summary.uptimeRatio, comparison?.result?.summary?.uptimeRatio, 'higher') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>Médiane</span>
        <strong>{{ formatDuration(result.summary.medianDurationSeconds) }}</strong>
        <em *ngIf="delta(result.summary.medianDurationSeconds, comparison?.result?.summary?.medianDurationSeconds, 'higher') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
      <article class="card">
        <span>Instables</span>
        <strong>{{ result.summary.unstableChargePointCount }}</strong>
        <em *ngIf="delta(result.summary.unstableChargePointCount, comparison?.result?.summary?.unstableChargePointCount, 'lower') as d" [ngClass]="d.tone">{{ d.text }}</em>
      </article>
    </div>

    <mat-expansion-panel class="alerts">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Alertes
          <span class="alert-counts">
            <span *ngIf="result.issues.length === 0">Aucune</span>
            <ng-container *ngIf="result.issues.length > 0">
              <span>{{ result.issues.length }}</span>
              <span class="danger" *ngIf="issueCount('DANGER') > 0">{{ issueCount('DANGER') }} danger</span>
              <span class="warning" *ngIf="issueCount('WARNING') > 0">{{ issueCount('WARNING') }} warning</span>
            </ng-container>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="alerts-empty" *ngIf="result.issues.length === 0">Aucune alerte sur cette fenêtre.</p>
      <div class="issues" *ngIf="result.issues.length > 0">
        <article class="issue" *ngFor="let issue of result.issues" [ngClass]="issue.severity">
          <mat-icon>{{ issue.severity === 'DANGER' ? 'error' : issue.severity === 'WARNING' ? 'warning' : 'info' }}</mat-icon>
          <div>
            <span class="issue-scope">{{ scopeLabel(issue.scope) }}</span>
            <p>{{ issue.message }}</p>
          </div>
        </article>
      </div>
    </mat-expansion-panel>

    <mat-tab-group>
      <mat-tab label="Organisations">
        <app-session-group-table [groups]="result.byNamespace" [baselineGroups]="comparison?.result?.byNamespace ?? null"></app-session-group-table>
      </mat-tab>
      <mat-tab label="Bornes">
        <app-session-group-table [groups]="result.byChargePoint" [baselineGroups]="comparison?.result?.byChargePoint ?? null" [showHardware]="true"></app-session-group-table>
      </mat-tab>
      <mat-tab label="Vendeurs">
        <app-session-group-table [groups]="result.byVendor" [baselineGroups]="comparison?.result?.byVendor ?? null"></app-session-group-table>
      </mat-tab>
      <mat-tab label="Modèles">
        <app-session-group-table [groups]="result.byModel" [baselineGroups]="comparison?.result?.byModel ?? null"></app-session-group-table>
      </mat-tab>
      <mat-tab label="Firmwares">
        <app-session-group-table [groups]="result.byFirmware" [baselineGroups]="comparison?.result?.byFirmware ?? null"></app-session-group-table>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</section>
